import React from 'react';

import { CoursesSection } from '../CoursesSection';
import { ActivationSection } from '../ActivationSection';

const School = ({
  locale,
  isRootAdmin,
  courses,
  student,
  status,
  createdAt,
  updatedAt,
  onCourseClick,
  onManageCoursesAccessClick,
  onGrantProAccessClick,
  onIssueCertificateForCourseClick,
  issuingCertificateCourseId,
}: {
  locale: any;
  isRootAdmin: any;
  courses: any;
  student: any;
  status: any;
  createdAt: any;
  updatedAt: any;
  onCourseClick: any;
  onManageCoursesAccessClick: any;
  onGrantProAccessClick: any;
  onIssueCertificateForCourseClick: any;
  issuingCertificateCourseId: string | null;
}) => (
  <>
    <ActivationSection
      {...status}
      locale={locale}
      student={student}
      createdAt={createdAt}
      updatedAt={updatedAt}
    />

    <CoursesSection
      isRootAdmin={isRootAdmin}
      courses={courses}
      locale={locale}
      onCourseClick={onCourseClick}
      onManageCoursesAccessClick={onManageCoursesAccessClick}
      onGrantProAccessClick={onGrantProAccessClick}
      onIssueCertificateForCourseClick={onIssueCertificateForCourseClick}
      issuingCertificateCourseId={issuingCertificateCourseId}
    />
  </>
);

export default React.memo(School) as any;
